import { useIntl } from 'react-intl';
import { Grid } from 'antd';
import { StyledTable } from 'styles/overrides';

export const Table = ({ pagination, ...props }) => {
  const intl = useIntl();
  const screens = Grid.useBreakpoint();

  return (
    <div>
      <StyledTable
        bordered
        pagination={
          pagination === false
            ? pagination
            : {
                position: ['bottomCenter'],
                showQuickJumper: true,
                showTotal: (total) =>
                  intl.formatMessage({ id: 'common.table.total' }, { total }),
                locale: { page: '' },
                ...pagination,
              }
        }
        scroll={{ x: screens.xl ? undefined : 'max-content' }}
        {...props}
      />
    </div>
  );
};
